import React from 'react';

const Settings = () => {
  return<>
        <div className='ml--40 mt--10'><h1>Settings</h1></div>        
    </>
}

export default Settings;